var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCardHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.614 27.996a.5.5 0 01-.482-.37L.767 11.334a.5.5 0 01.353-.61l6.336-1.7v12.6a.5.5 0 00.5.5h8.28l.632 2.354a.5.5 0 01-.354.612l-10.77 2.889a.5.5 0 01-.13.017h0z",
    stroke: "#00B8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.105 22.127H7.955a.5.5 0 01-.5-.5V4.76a.5.5 0 01.5-.5h8.119L12.55 17.41a.5.5 0 00.354.612l6.7 1.8v1.809a.5.5 0 01-.5.495h0z",
    stroke: "#00B8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.754 1.605l.13-.483a.482.482 0 01.232-.304.482.482 0 01.38-.05l10.77 2.882a.482.482 0 01.304.233c.069.12.085.246.05.38l-4.36 16.292a.482.482 0 01-.233.304.482.482 0 01-.38.05l-10.77-2.882a.482.482 0 01-.303-.233.482.482 0 01-.05-.38l4.23-15.809z",
    stroke: "#FFF"
  }))));
}

export default SvgIconCardHand;